import React from 'react';
import { BrowserRouter } from 'react-router';
import { AuthStateType, useAuth } from '@/libs/device-auth';
import Routing from './Routing';
import { LoadingSpinner } from '@/components/loading/Loading';
import { ApolloProvider } from '@apollo/client';
import { createApolloClient } from '@/services/apolloClient';
import { sessionService } from '@/services/sessionService';
import { APP_CONFIG } from './config';

const client = createApolloClient({
  graphqlUri: APP_CONFIG.API_URL,
  sessionSvc: sessionService,
});

export const AppContent: React.FC = () => {
  const { isLoading, authStateType } = useAuth();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (authStateType === AuthStateType.INITIALIZING) {
    return <div className="app-loading">Initializing...</div>;
  }

  return (
    <>
      <ApolloProvider client={client}>
        <BrowserRouter>
          <Routing />
        </BrowserRouter>
      </ApolloProvider>
    </>
  );
};
